import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, {
  siteKey: '6Ld0qKsZAAAAAI5rPS4W0cROs7tlWha-sWYVnAOS',
  loaderOptions: {
    autoHideBadge: true,
  },
});
